// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SELLER_STATUS_MESSAGE_FROM_SELLER = "Ozn\u00e1men\u00ed od prodejce";
